export const siteData = {
  companyName: "All The Details",
  companyShort: "ATD",
  tagline: "Steel & Bronze Windows & Doors",
  phone: "203.218.3281",
  email: "jcoursen@atdetails.com",
  website: "atdetails.com",
};

export const navigation = [
  { label: "Collection", href: "#collection" },
  { label: "Markets", href: "#markets" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export const heroData = {
  subtitle: "A Lookbook",
  titleLine1: "Steel & Bronze",
  titleLine2: "Windows & Doors",
  tagline: "Envisioned. Crafted. Perfected.",
  backgroundImage:
    "https://images.squarespace-cdn.com/content/v1/653fc052c3b3260e0ddc263c/de39c228-249f-49b5-bc2f-c30900d13fc5/living+room+wide.jpg",
};

export const lookbookItems = [
  {
    id: 1,
    title: "Sands Point, NY",
    subtitle: "Steel Windows & Doors",
    image:
      "https://images.squarespace-cdn.com/content/v1/653fc052c3b3260e0ddc263c/1769630562720-4ZH4KKECPK57GUNDO7M4/26FOREST1+resize.jpeg",
    size: "large",
  },
  {
    id: 2,
    title: "Fairfield, CT",
    subtitle: "Interior Steel Office Doors",
    image:
      "https://images.squarespace-cdn.com/content/v1/653fc052c3b3260e0ddc263c/1770660630107-EULWJEXXJPMGPAERXCE3/DK9A6580.jpg",
    size: "small",
  },
  {
    id: 3,
    title: "Bedford, NY",
    subtitle: "Aluminum Skylight",
    image:
      "https://images.squarespace-cdn.com/content/v1/653fc052c3b3260e0ddc263c/1768853066752-VT214PVOB3W6YC7UIX04/FullSizeRender+9+%281%29.jpeg",
    size: "small",
  },
  {
    id: 4,
    title: "Darien, CT",
    subtitle: "Steel Bifold Doors & Windows",
    image:
      "https://images.squarespace-cdn.com/content/v1/653fc052c3b3260e0ddc263c/1759509530621-L2NNGQ6KSPZSL9ACBR6H/2024_09_17+TRI+0771XXX.jpg",
    size: "large",
  },
  {
    id: 5,
    title: "Greenwich, CT",
    subtitle: "Wine Wall — Steel & Glass",
    image:
      "https://images.squarespace-cdn.com/content/v1/653fc052c3b3260e0ddc263c/1724704823950-GBDQIBB8H6WIJN3O37YR/38BrucePark-01+resize.jpg",
    size: "small",
  },
  {
    id: 6,
    title: "Bedford, NY",
    subtitle: "Steel Conservatory",
    image:
      "https://images.squarespace-cdn.com/content/v1/653fc052c3b3260e0ddc263c/1764874323294-O85H0C8LI29UM5FHMNS0/IMG_9653.jpg",
    size: "small",
  },
  {
    id: 7,
    title: "Pound Ridge, NY",
    subtitle: "Bi-Folding & Lift-and-Slide Doors",
    image:
      "https://images.squarespace-cdn.com/content/v1/653fc052c3b3260e0ddc263c/b81cc208-cfe9-43a7-9cb9-053751d9bb55/dining+wide+window+walls.jpg",
    size: "full",
  },
  {
    id: 8,
    title: "New York, NY",
    subtitle: "Historic Brownstone — Steel Doors",
    image:
      "https://images.squarespace-cdn.com/content/v1/653fc052c3b3260e0ddc263c/1764867197937-GY4DSESMXX0VRIFRU15D/OT2432744+Medium+res.jpg",
    size: "small",
  },
  {
    id: 9,
    title: "Westport, CT",
    subtitle: "Interior Sliding Doors",
    image:
      "https://images.squarespace-cdn.com/content/v1/653fc052c3b3260e0ddc263c/1714518525434-UU93ELOBD09QP45DMJ6M/IMG_5338.jpg",
    size: "small",
  },
  {
    id: 10,
    title: "Madison, CT",
    subtitle: "Steel Windows",
    image:
      "https://images.squarespace-cdn.com/content/v1/653fc052c3b3260e0ddc263c/1765987854467-5PEKYA5JF8CND6AR416A/2025.10.19-1544+%28web%29.jpg",
    size: "large",
  },
  {
    id: 11,
    title: "Naples, FL",
    subtitle: "Steel Interior Partitions",
    image:
      "https://images.squarespace-cdn.com/content/v1/653fc052c3b3260e0ddc263c/1768420601444-FVGIFQJKW6P58H1F7CTT/IMG_8588.jpg",
    size: "small",
  },
  {
    id: 12,
    title: "Nassau County, LI",
    subtitle: "Steel Panels & Wine Cellar",
    image:
      "https://images.squarespace-cdn.com/content/v1/653fc052c3b3260e0ddc263c/1707861849738-KGLEU61W0SN76D1S6960/Kitchen+04_502.jpeg",
    size: "small",
  },
  {
    id: 13,
    title: "Sands Point, NY",
    subtitle: "Dining Room — Steel Fixed Windows",
    image:
      "https://customer-assets.emergentagent.com/job_steel-solutions-test/artifacts/5nr7fpko_26FOREST4%2Bresize.webp",
    size: "large",
  },
  {
    id: 14,
    title: "Sands Point, NY",
    subtitle: "Kitchen & Dining — Steel Casements",
    image:
      "https://customer-assets.emergentagent.com/job_steel-solutions-test/artifacts/lymgodx7_26FOREST5%2Bresize.webp",
    size: "small",
  },
  {
    id: 15,
    title: "Sands Point, NY",
    subtitle: "Kitchen — Steel Windows & Marble Island",
    image:
      "https://customer-assets.emergentagent.com/job_steel-solutions-test/artifacts/na0wjrwm_26FOREST3%2Bresize.webp",
    size: "large",
  },
];

export const markets = [
  {
    id: "east",
    region: "East Coast",
    locations: "Connecticut, New York, New Jersey, Massachusetts",
    description:
      "Our flagship market. From Greenwich estates to Manhattan brownstones, we craft steel and bronze elements for the Northeast's most distinguished architectural projects.",
    image:
      "https://images.squarespace-cdn.com/content/v1/653fc052c3b3260e0ddc263c/1722280036419-UF2WGUWAMX5W8QHEQWA9/7.jpg",
  },
  {
    id: "florida",
    region: "Florida",
    locations: "Naples, Miami, Palm Beach, Fort Lauderdale",
    description:
      "Hurricane-rated steel and impact-resistant glass systems engineered for Florida's demanding climate. Full design-build service from our Naples showroom.",
    badge: "Hurricane Rated",
    image:
      "https://images.squarespace-cdn.com/content/v1/653fc052c3b3260e0ddc263c/1768420601444-FVGIFQJKW6P58H1F7CTT/IMG_8588.jpg",
  },
  {
    id: "west",
    region: "West Coast",
    locations: "California, Pacific Northwest",
    description:
      "Expanding our reach to serve the West Coast's innovative architectural community with the same precision and craftsmanship that defines our East Coast legacy.",
    image:
      "https://images.squarespace-cdn.com/content/v1/653fc052c3b3260e0ddc263c/1722279168649-F2WXXERZNBJVCNFT4FTJ/Serebe+Exterior+resize.jpg",
  },
];

export const editorialSpread = {
  title: "Pound Ridge, NY",
  architect: "Teo Siguenza",
  caption:
    "Soaring double-height ceilings meet expansive sliding glass doors overlooking the river. Bi-folding doors, lift-and-slide systems, and a custom angled bay window with cremone bar hardware.",
  credit: "As featured in Architectural Digest",
  image:
    "https://images.squarespace-cdn.com/content/v1/653fc052c3b3260e0ddc263c/1722280097424-Q7UTAQONUCHE1BQUGV61/living+room+wide.jpg",
};

export const aboutData = {
  quote:
    "We believe that world-class design and building performance are inseparable.",
  body: "All The Details designs and manufactures custom steel, bronze, and aluminum windows and doors. Since 1994, founders John & Linda Coursen have built a legacy of architectural excellence\u2014collaborating with architects, designers, builders, and developers to deliver exceptional detailing from macro vision to micro finish.",
  founderImage:
    "https://images.squarespace-cdn.com/content/v1/653fc052c3b3260e0ddc263c/94192831-6695-4ca0-80c3-cae21ae3846b/DSCF7956.jpg",
  detailImage:
    "https://images.squarespace-cdn.com/content/v1/653fc052c3b3260e0ddc263c/514904b9-8393-4f88-9f76-e698ebdd32c8/DK9A4467.jpg",
  showroomImage:
    "https://images.squarespace-cdn.com/content/v1/653fc052c3b3260e0ddc263c/16b8883c-562c-4264-b97e-abc3c365e1c5/DK9A4454.jpg",
};

export const locations = [
  {
    name: "Connecticut",
    address: "1221 Post Road E, Westport, CT 06880",
  },
  {
    name: "Florida",
    address: "6320 Shirley Street, Naples, FL 34109",
  },
];
